import React from "react";
import { get } from "lodash";
import {
    InputField,
    FormRow,
    TextareaField,
    CurrencyInput,
    Address,
} from "@cortexglobal/rla-components";
import { trans } from "@cortexglobal/rla-intl";
import { useUser } from "@cortexglobal/cortex-auth-redux";

import { FormWrapper, YesNoSelector } from "./formLayoutComponents";

const VenueForm = ({ loadingState, errors, params, onChange }) => {
    const { user } = useUser();
    console.log("user", user);

    return (
        <FormWrapper>
            <FormRow
                helpText={trans("Required")}
                label={trans("Venue name")}
                name={"venue_name"}
                error={get(errors, "venue_name")}
                required
            >
                <InputField
                    name="venue_name"
                    onChange={(e) => onChange(e.name, e.value)}
                    disabled={loadingState === "loading"}
                    value={get(params, "venue_name", "")}
                />
            </FormRow>

            <FormRow
                helpText={trans("Optional")}
                label={trans("Venue reference")}
                name={"venue_reference"}
                error={get(errors, "venue_reference")}
            >
                <InputField
                    name="venue_reference"
                    onChange={(e) => onChange(e.name, e.value)}
                    disabled={loadingState === "loading"}
                    value={get(params, "venue_reference", "")}
                />
            </FormRow>

            <FormRow
                helpText={trans("Optional")}
                label={trans("Venue contact name")}
                name={"venue_primary"}
                error={get(errors, "venue_primary")}
            >
                <InputField
                    name="venue_primary"
                    onChange={(e) => onChange(e.name, e.value)}
                    disabled={loadingState === "loading"}
                    value={get(params, "venue_primary", "")}
                />
            </FormRow>

            <FormRow
                helpText={trans("Optional")}
                label={trans("Venue phone number")}
                name={"venue_phone"}
                error={get(errors, "venue_phone")}
            >
                <InputField
                    name="venue_phone"
                    onChange={(e) => onChange(e.name, e.value)}
                    disabled={loadingState === "loading"}
                    value={get(params, "venue_phone", "")}
                />
            </FormRow>

            <FormRow
                helpText={trans("Optional")}
                label={trans("Venue email address")}
                name={"venue_email"}
                error={get(errors, "venue_email")}
            >
                <InputField
                    name="venue_email"
                    onChange={(e) => onChange(e.name, e.value)}
                    disabled={loadingState === "loading"}
                    value={get(params, "venue_email", "")}
                />
            </FormRow>

            <FormRow
                helpText={trans("Optional")}
                label={trans("Venue cost")}
                name={"venue_cost"}
                error={get(errors, "venue_cost")}
            >
                <CurrencyInput
                    name="venue_cost"
                    onChange={(e) => onChange(e.name, e.value)}
                    disabled={loadingState === "loading"}
                    value={get(params, "venue_cost", "")}
                />
            </FormRow>

            <FormRow
                helpText={trans("Optional")}
                label={trans("Is the event indoors?")}
                name={"indoor"}
                error={get(errors, "indoor")}
            >
                <YesNoSelector
                    name="indoor"
                    value={get(params, "indoor")}
                    onChange={onChange}
                    loading={loadingState === "loading"}
                />
            </FormRow>

            <Address
                locale={user?.language}
                address1={{
                    helpText: trans("Optional"),
                    label: trans("Venue Building"),
                    name: "address_building",
                    error: get(errors, "address_building"),
                    value: get(params, "address_building", ""),
                }}
                address2={{
                    helpText: trans("Optional"),
                    label: trans("Address Street"),
                    name: "address_street",
                    error: get(errors, "address_street"),
                    value: get(params, "address_street", ""),
                }}
                address3={{
                    helpText: trans("Optional"),
                    label: trans("Address Neighbourhood"),
                    name: "address_neighbourhood",
                    error: get(errors, "address_neighbourhood"),
                    value: get(params, "address_neighbourhood", ""),
                }}
                address4={{
                    helpText: trans("Optional"),
                    label: trans("Address Suburb"),
                    name: "address_suburb",
                    error: get(errors, "address_suburb"),
                    value: get(params, "address_suburb", ""),
                }}
                town={{
                    helpText: trans("Required"),
                    label: trans("Address City"),
                    name: "address_city",
                    error: get(errors, "address_city"),
                    value: get(params, "address_city", ""),
                }}
                state={{
                    helpText: trans("Optional"),
                    label: trans("Address State"),
                    name: "address_state",
                    error: get(errors, "address_state"),
                    value: get(params, "address_state", ""),
                }}
                postcode={{
                    helpText: trans("Required"),
                    label: trans("Venue Postcode"),
                    name: "postcode",
                    error: get(errors, "postcode"),
                    value: get(params, "postcode", ""),
                }}
                country={{
                    helpText: trans("Optional"),
                    label: trans("Venue Country"),
                    name: "country",
                    error: get(errors, "country"),
                    value: get(params, "country", ""),
                }}
                render={(addressField) => {
                    return (
                        <FormRow
                            key={addressField.name}
                            helpText={addressField.helpText}
                            label={addressField.label}
                            name={addressField.name}
                            error={addressField.error}
                        >
                            <InputField
                                name={addressField.name}
                                onChange={(e) => onChange(e.name, e.value)}
                                disabled={loadingState === "loading"}
                                value={addressField.value}
                            />
                        </FormRow>
                    );
                }}
            />
            <FormRow
                helpText={trans("Optional")}
                label={trans("Additional venue notes")}
                name={"venue_notes"}
                error={get(errors, "venue_notes")}
            >
                <TextareaField
                    name="venue_notes"
                    onChange={(e) => onChange(e.name, e.value)}
                    error={get(errors, "venue_notes")}
                    disabled={loadingState === "loading"}
                    value={get(params, "venue_notes", "")}
                />
            </FormRow>
        </FormWrapper>
    );
};

export default VenueForm;
